import styled from "styled-components";

export const CheckboxRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 20px;
`;

export const CheckboxLabel = styled.label`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  cursor: pointer;
`;

export const StyledCheckbox = styled.input.attrs({ type: "checkbox" })`
  width: 24px;
  min-width: 24px;
  height: 24px;
  accent-color: ${({ theme }) => theme.colors.primary300};
  border-radius: 4px;
  border: 2px solid ${({ theme }) => theme.colors.netural300};
  cursor: pointer;
`;

export const CheckboxLink = styled.a`
  color: ${({ theme }) => theme.colors.primary300};
  font-weight: 600;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
